import BaseInputField from './BaseInputField';
import StringHelper from '../../../../components/StringHelper';

class RangeInputField extends BaseInputField {
	getValue() {
		if (!StringHelper.isNumeric(this._$input.val())) {
			return '';
		}

		const maxValue = this._$input.data('max-value');
		let value = Number.parseInt(this._$input.val());

		//this is not to let show empty vendors list/podium
		if (value && maxValue && value > maxValue) {
			value = maxValue;
		}

		return String(value);
	}

	getVendors() {
		return this._getVendorsByRangeValue(this.getValue(), super.getVendors());
	}

	_getVendorsByRangeValue(value, inputDataVendors) {
		let vendorsInRange = [];

		for (const [range, vendors] of Object.entries(inputDataVendors)) {
			let [start, end] = range.split('-');
			start = start ? Number.parseInt(start) : start;
			end = end ? Number.parseInt(end) : end;

			if (!end) {
				end = start;
				start = null;
			}

			if (start === null && value >= end) {
				vendorsInRange = vendors;
				break;
			} else if (start !== null && value >= start && value <= end) {
				vendorsInRange = vendors;
				break;
			}
		}

		return vendorsInRange;
	}
}

export default RangeInputField;
